<section class="footer bg-black p-4">
  <div class="container">
    <div class="row">
      <div class="col-12 col-lg-3">
        <p class="text-white fw-bold" translate>footer_about</p>
        <a
          *ngFor="let item of about"
          title="{{ item.routeName }}"
          href="{{ item.link }}"
          class="font-16 pb-4 d-block fw-light text-decoration-none text-white"
          translate
          >{{ item.navName }}</a
        >
      </div>
      <div class="col-12 col-lg-3">
        <p class="text-white fw-bold" translate>casino</p>
        <a
          *ngFor="let item of casino"
          title="{{ item.routeName }}"
          href="{{ item.link }}"
          class="font-16 pb-4 d-block fw-light text-decoration-none text-white"
          translate
          >{{ item.navName }}</a
        >
      </div>
      <div class="col-12 col-lg-3">
        <p class="text-white fw-bold" translate>footer_sport</p>
        <a
          *ngFor="let item of sport"
          title="{{ item.routeName }}"
          href="{{ item.link }}"
          class="font-16 pb-4 d-block fw-light text-decoration-none text-white"
          translate
          >{{ item.navName }}</a
        >
      </div>

      <div class="col-12 col-lg-3 mb-4">
        <div class="btn-group language" dropdown>
          <div
            dropdownToggle
            type="button"
            class="dropdown-toggle amountType d-flex align-items-center"
          >
            <img
              class="flag-icon"
              src="./assets/images/flags/{{ selectedLanguage?.flag }}.svg"
              alt=""
            />
            <span class="ms-1 font-13 text-capitalize fw-regular text-white">{{
              selectedLanguage?.name
            }}</span>
            <!-- <svg-icon class="dropdown" src="./assets/images/svg-icons/download.svg"></svg-icon> -->
          </div>
          <ul
            *dropdownMenu
            class="dropdown-menu dropdown-menu-right"
            role="menu"
          >
            <li
              class="p-2 cursor-pointer"
              role="menuitem"
              *ngFor="let lang of languagesList"
              (click)="changeLanguage(lang.value)"
            >
              <img src="./assets/images/flags/{{ lang.flag }}.svg" alt="" />
              <span class="font-12">{{ lang.name }}</span>
            </li>
          </ul>
        </div>
      </div>

      <div class="col-12 col-lg-12">
        <div class="d-sm-flex align-items-center justify-content-center gap-3">
          <img src="./assets/images/footer/footer (11).svg" alt="" />
          <img src="./assets/images/footer/footer (12).svg" alt="" />
          <img src="./assets/images/footer/footer (13).svg" alt="" />
          <img src="./assets/images/footer/footer (1).svg" alt="" />
          <img src="./assets/images/footer/footer (2).svg" alt="" />
          <img src="./assets/images/footer/footer (3).svg" alt="" />
          <img src="./assets/images/footer/footer (4).svg" alt="" />
          <img src="./assets/images/footer/footer (5).svg" alt="" />
          <img src="./assets/images/footer/footer (6).svg" alt="" />
          <img src="./assets/images/footer/footer (7).svg" alt="" />
          <img src="./assets/images/footer/footer (8).svg" alt="" />
          <img src="./assets/images/footer/footer (9).svg" alt="" />
          <img src="./assets/images/footer/footer (10).svg" alt="" />
        </div>
        <!-- <p class="font-14 text-white fw-light text-center pt-4" translate>
          {{ "footer_content" }}
        </p> -->
      </div>
      <div class="col-12 col-lg-12 text-center mt-4 mb-5">
        <img src="./assets/images/footer/footer15.svg" alt="" />
      </div>
      <div class="col-12 col-lg-12 text-center">
        <p class="font-11 text-white" translate>{{ "footer_support" }}</p>
      </div>
      <div class="col-12 col-lg-12 text-center">
        <p class="font-11 text-white" translate>{{ "footer_complaint" }}</p>
      </div>
      <div class="col-12 col-lg-12 text-center">
        <p class="font-11 text-white" translate>{{ "footer_Affiliates" }}</p>
      </div>
      <div class="col-12 col-lg-12 text-center">
        <p class="font-11 text-white">
          {{
            "footer_copyright"
              | translate
                : {
                    currentYear
                  }
          }}
        </p>
      </div>
      <div class="col-12 col-lg-12 my-5 mx-auto mb-md-0">
        <div class="d-flex gap-3 justify-content-center">
          <a
            href="https://www.instagram.com/wsmcasino/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="./assets/images/footer/f-instagram.svg" alt="" />
          </a>
          <a
            href="https://twitter.com/wsmcasino"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="./assets/images/footer/f-twitter.svg" alt="" />
          </a>
          <a
            href="https://t.me/wallst_memes"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="./assets/images/footer/f-telegram.svg" alt="" />
          </a>
          <a
            href="https://dexscreener.com/bsc/0xf420603317a0996a3fce1b1a80993eaef6f7ae1a"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="./assets/images/footer/dexscreen.svg" alt="" />
          </a>
        </div>
      </div>
    </div>
  </div>
</section>
